import * as React from 'react';
import * as ReactGA from 'react-ga';
import {compose} from "recompose";

import {Route, Switch, withRouter} from 'react-router-dom';

import Main from './layouts/Main/Main';

import {withAuthentication, withUser} from './components/Firebase/';

// Google Analytics tracking only in production
// ReactGA.initialize('UA-132773938-1');

interface IProps {
  history: any;
}

class App extends React.Component<IProps, {}> {
  
  componentDidMount(): void {
    this.props.history.listen((location: any) => ReactGA.pageview(location.pathname))
  }

  public render() {
    return (
      <Switch>
        <Route path='' component={Main} />
      </Switch>
    );
  }
}

export default compose(
  withRouter,
  withUser,
  withAuthentication,
)(App);

